export { default } from '@/features/campaignPage/Page/Image';
